import React from 'react';
import './App.css';


function App({children}) {
  return (
    <div className="App">
      <div className="bg-wrapper">
        <span className="dark-overlay"/>
        <img src="/images/logo_purple.png" alt="Bryt studio logo" id = "bg-img" />
      </div>
      
{children}
    </div>
  );
}

export default App;
